import React, { useState } from "react";
import "./DynamicInputComponent.css";
import { Input } from 'antd';
import { RiPencilFill } from "react-icons/ri";
const DynamicInputComponent = ({defaultValue}) => {
    const [editable, setEditable] = useState(false);
    const [inputValue, setInputValue] = useState(defaultValue);

    const handleEditClick = () => {
        setEditable(prev=>!prev);
    };

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };
    return <>
        <div id="input-styles">
            <Input
                placeholder=""
                value={inputValue}
                onChange={handleChange}
                disabled={!editable}
            />&nbsp;
            <RiPencilFill
                style={{ fontSize: "1.2rem", cursor: "pointer",color:"#6E6E6E" }}
                onClick={handleEditClick}
            />
        </div>
    </>
}

export default DynamicInputComponent